import React, { useCallback } from 'react'
import { I18n } from '@front/volcanion/'
import { TableCell } from '@mui/material'

import { TimeUtils } from '@front/volcanion/utils'
import { MenuSelectorField, ModelMenuSelectorField, NumberField, TextField, ModelAutocompleteField } from '@front/squirtle'
import { TextCell } from '@abra/elements/table/cells/basics'

const validateCodeLength = (value) => value && value.length < 4 ? I18n.t('voucher.error.code_min_length') : undefined
const mutateCompanyService = (elem) => ({ label: `${elem?.contract?.client_id} - ${elem?.client_id}`, ...elem })
const autocompleteQueryMutator = (q) => ({
  or: [
    { client_id: q },
    { contract: { client_id: q } }
  ]
})
const createGetOptionProps = (props) => ({ _typography: { color: !!props?.value ? 'green' : 'orange' } })


const Row = ({ row, company }) => {
  const validateCompanyFilter = useCallback(() => !!company, [company])

  return (
    <>
      <TableCell size={'small'} sx={{ minWidth: 100 }}>
        <TextField
          name='code'
          inputProps={{ maxLength: 10 }}
          normalize={_.toUpper}
          validate={validateCodeLength}
        />
      </TableCell>
      <TableCell size={'small'} sx={{ minWidth: 150 }}>
        <ModelMenuSelectorField
          name={'schedule'}
          model_name='schedule'
          labelKeys={['name']}
          searchMode='search'
          config={{
            initial_filter: { type: 'voucher' },
            forced_filter: { type: 'voucher' }
          }}
          required
        />
      </TableCell>
      <TableCell size={'small'} sx={{ minWidth: 150 }}>
        <ModelAutocompleteField
          name={'companyservice'}
          model_name='companyservice'
          config={{
            initial_filter: { contract: { company } },
            forced_filter: { contract: { company } },
            validate_filter: validateCompanyFilter,
            watchers: [company],
            populate: ['contract'],
            mutator: mutateCompanyService
          }}
          autocompleteMutator={autocompleteQueryMutator}
          required
          selectFirst={false}
          searchMode='search'
          debounceTime={400}
          renderInputProps={{
            inputProps: { style: { textAlign: 'center' } }
          }}
        />
      </TableCell>
      <TableCell size={'small'} sx={{ width: 90 }}>
        <NumberField
          name='max_user_usage'
          type='number'
          allowNull
          nullValue={null}
          minValue={0}
          InputProps={{
            inputProps: { style: { textAlign: 'center' } }
          }}
        />
      </TableCell>
      <TableCell size={'small'} sx={{ width: 90 }}>
        <NumberField
          name='max_global_usage'
          type='number'
          allowNull
          nullValue={null}
          minValue={0}
          InputProps={{
            inputProps: { style: { textAlign: 'center' } }
          }}
        />
      </TableCell>
      <TableCell size={'small'} sx={{ width: 80 }}>
        <NumberField
          name='amount'
          type='float'
          InputProps={{
            inputProps: { style: { textAlign: 'center' } }
          }}
          minValue={0}
          required
        />
      </TableCell>
      <TableCell size={'small'} sx={{ width: 80 }}>
        <MenuSelectorField
          name={'active'}
          options={[
            { label: I18n.t('status.active'), value: true },
            { label: I18n.t('status.inactive'), value: false },
          ]}
          getOptionProps={createGetOptionProps}
          allowNone={false}
        />
      </TableCell>
      <TableCell size={'small'} sx={{ width: 100 }}>
        <TextCell value={TimeUtils.formatDateBackToFront(row?.createdAt)} />
      </TableCell>
      <TableCell size={'small'} sx={{ minWidth: 120 }}>
        <TextCell value={_.join(_.compact([row?.createdBy?.info?.first_name, row?.createdBy?.info?.last_name]), ' ')} />
      </TableCell>
    </>
  )
}
export default React.memo(Row)
